import React, { useEffect, useState } from 'react';
import './App.css';
import Controller from './Controller/Controller';
import 'semantic-ui-css/semantic.min.css'

const ALLOWED_PARENT_ORIGIN = 'https://crm.axcap.ae';

function App() {
  const [authorized, setAuthorized] = useState(false)
  const [accessChecked, setAccessChecked] = useState(() => window.self === window.top)
  const [bitrixUserId, setBitrixUserId] = useState(null)

  useEffect(() => {
    if (window.self === window.top) {
      setAuthorized(false);
      setAccessChecked(true);
      return;
    }

    const accessTimeout = window.setTimeout(() => {
      setAccessChecked(true);
    }, 1500);

    const handleParentMessage = (event) => {
      if (event.origin !== ALLOWED_PARENT_ORIGIN) {
        return;
      }

      if (event.data?.type !== 'PARENT_URL') {
        return;
      }

      if (event.data.url?.startsWith(ALLOWED_PARENT_ORIGIN)) {
        setAuthorized(true);
        setBitrixUserId(event.data.userId || null);
      }

      setAccessChecked(true);
      window.clearTimeout(accessTimeout);
    }

    window.addEventListener('message', handleParentMessage);

    return () => {
      window.clearTimeout(accessTimeout);
      window.removeEventListener('message', handleParentMessage);
    }
  }, []);

  if (!accessChecked) {
    return <div className="access-state">Checking access...</div>
  }

  if(!authorized){
    return <div className="access-state">Access Denied</div>
  }

  return (
    <div className="App">
      <Controller bitrixUserId={bitrixUserId}/>
    </div>
  );
}

export default App;
